// extracted by css-extract-rspack-plugin
export default {"NewRulesetButton":"OverviewPage-module__NewRulesetButton___f6Ec","BPConversionBanner":"OverviewPage-module__BPConversionBanner__cVG9U"};